import rootScope from '@lib/rootScope';
import wrapSticker from '@components/wrappers/sticker'
import {Modify} from '@types';

export default async function wrapStickerEmoji(options: Modify<Parameters<typeof wrapSticker>[0], {
  div: HTMLElement,
  doc?: never
}>) {
  const {
    emoji,
    div,
    managers = rootScope.managers
  } = options;
  const doc = await managers.appStickersManager.getAnimatedEmojiSticker(emoji);
  if(!doc) {
    div.classList.add('media-sticker-wrapper');
    throw new Error('no sticker');
  }

  return wrapSticker({
    doc,
    play: true,
    loop: false,
    ...options
  });
}
